<app-page titre="Export BPF" [enteteSimple]="false">
    <div class="content" content>
        <div class="text">
            <p>
                Chaque année, en tant qu'organisme de formation, vous devez transmettre un bilan pédagogique et financier (BPF) qui retrace votre activité en matière de formation professionnelle au titre du dernier exercice comptable clos.
            </p>
            <p>
                Pour cela il vous suffit de renseigner toutes les informations nécessaires au remplissage du Cerfa réglementaire N° 10443*17 relatif au BPF.
            </p>
            <div class="buttons">
                <div class="buttons__align">
                    <button class="button-main" (click)="openCerfa()">Télécharger le Bilan Pédagogique et Financier (Cerfa)</button>
                    <button class="button-main" (click)="openNotice()">Télécharger la notice du cerfa du Bilan Pédagogique et Financier</button>
                </div>
                <button class="button-main" (click)="openGuid()">Télécharger le guide pour remplir le Bilan Pédagogique Financier</button>
            </div>
            <p>
                Vous avez jusqu’au <span>30 avril 2026</span> pour faire votre télédéclaration sur le site <a href="https://efpconnect.emploi.gouv.fr/auth/realms/efp/protocol/cas/login?TARGET=https%3A%2F%2Fwww.monactiviteformation.emploi.gouv.fr%2Fmon-activite-formation%2F" target="_blank">EPP Connect</a>
            </p>
            <p>
                Pour vous aider à faire cette déclaration, nous mettons à votre disposition, sur simple demande, un fichier BPF avec vos données.
            </p>
            <p>
                Pour recevoir votre fichier, contactez directement notre équipe via votre espace client : <a href="https://portail.axess.fr" target="_blank">https://portail.axess.fr</a>
                <br>
                (en indiquant juste "Demande de BPF" dans l'objet de votre demande).
            </p>
        </div>
        <div class="cerfa">
            <img src="../../../assets/images/cerfa.png" alt="">
        </div>
    </div>
</app-page>
